<template>
  <div id="assessment-framework">
   <dash-header :pages="breadCrumbsPages" :dashboardTitle="getDashboardTitle()" />
    <a-layout id="components-layout-demo-custom-trigger">
        <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.admin"
        />
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }">
          <a-steps :current="currentStep" v-model="currentStep" style="margin-bottom: 10px;" size="small" >
            <a-step
            v-for="(item, itemIndex) in steps"
            :key="itemIndex"
            :title="item.title"
            @handleStepClick="handleStepClick(itemIndex)"
            :id="item.title"
            >
            </a-step>
          </a-steps>
          <a-divider v-if="steps[currentStep] && ! steps[currentStep].editing">
            {{steps[currentStep].subTitle}} <a-icon  type="edit" @click="handleEditSubTitle($event, currentStep)" />
          </a-divider>
          <div v-else>
            <a-input :defaultValue="steps[currentStep].subTitle" @change="udpateEditingSubTitle($event)" v-if="steps[currentStep]">
              <a-icon type="check" slot="addonAfter" @click="updateSubTitle($event, currentStep, steps[currentStep].subTitle)"/>
            </a-input>
          </div>
          <a-divider></a-divider>
          <a-collapse accordion v-if="steps[currentStep]" :expand-icon-position="expandIconPosition">
            <a-collapse-panel
              :key="tabIndex+'_'+currentStep"
              v-for="(tab, tabIndex) in steps[currentStep].content"
            >
              <div slot="header" v-if="! tab.editing">
                {{tab.heading}}
                <span class="edit-button" slot="extra">
                  <a-popconfirm
                    title="Are you sure delete this question heading?"
                    ok-text="Yes"
                    cancel-text="No"
                    @confirm="confirmDeleteHeading(tabIndex)"
                    style="float: right; margin-left: 10px;"
                  >
                    <a-icon slot="icon" type="delete" style="color: red" />
                    <a-icon type="delete" />
                  </a-popconfirm>
                  <a-icon  type="edit" @click="handleEditHeading($event, tabIndex)" style="float: right;"/>
                </span>
              </div>
              <div slot="header" v-else>
                <a-input :default-value="tab.heading" @change="udpateEditingHeading($event)">
                  <a-icon type="check" slot="addonAfter" @click="updateHeading($event, tabIndex, tab.heading)"/>
                </a-input>
              </div>
              <a-list
                itemLayout="horizontal"
                :dataSource="tab.questions"
              >
                <a-list-item slot="renderItem" slot-scope="item, questionIndex">
                  <a-list-item-meta>
                    <h3 slot="title" v-if="! item.editing">
                      {{(currentStep+1)+'.'+(tabIndex+1)+'.'+(questionIndex+1)+' '+item.question}}
                      <span class="edit-button">
                        <a-popconfirm
                          title="Are you sure delete this question heading?"
                          ok-text="Yes"
                          cancel-text="No"
                          @confirm="confirmDeleteQuestion(tabIndex, questionIndex)"
                          style="float: right; margin-left: 10px;"
                        >
                          <a-icon slot="icon" type="delete" style="color: red" />
                          <a-icon type="delete" />
                        </a-popconfirm>
                        <a-icon slot="extra" type="edit" @click="handleEditQuestion($event, tabIndex, questionIndex)" style="float: right;"/>
                      </span>
                    </h3>

                    <div slot="title" v-else>
                      <a-input :default-value="item.question" @change="udpateEditingQuestion($event)">
                        <a-icon type="check" slot="addonAfter" @click="updateQuestion($event, tabIndex, questionIndex, item.question)"/>
                      </a-input>
                    </div>

                    <div slot="description" :style="{margin: '20px'}">
                      <a-checkbox @change="checkAdminOnly($event, tabIndex, questionIndex)" :defaultChecked="item.adminOnly">
                        Admin Only
                      </a-checkbox>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
                <div class="adding-question" v-if="isAddingQuestion" style="margin-top: 20px;">
                  <a-input v-model="newQuestion">
                    <a-icon type="check" slot="addonAfter" @click="addQuestion(tabIndex)" />
                  </a-input>
                </div>
                <a-divider>Domain Score</a-divider>
                <div class="domain-score" style="text-align: center; ">
                  <a-input-group compact>
                    <a-input
                      :default-value="domainScoreValue.key"
                      size="small"
                      style="width: 20%; margin-right: 30px;"
                      v-for="(domainScoreValue) in sortDomainScore(tab.domainScore)"
                      :key="domainScoreValue.value"
                      @change="handleDomainChange($event)"
                      type="number"
                    >

                      <span style="cursor: pointer;" slot="addonAfter" @click="saveDomainScore(tabIndex, domainScoreValue.key, domainScoreValue.value)">{{domainScoreValue.value}}<a-icon type="check"/>
                      </span>
                    </a-input>
                  </a-input-group>
                </div>
                <a-divider />
                <!-- <a-list-item> -->
                  <div style="text-align: center;  margin: auto">
                    <a-tooltip>
                      <template slot="title">
                        Add Question
                      </template>
                      <a-icon type="plus-circle" theme="twoTone" two-tone-color="#52c41a" :style="{fontSize: '15px'}" @click="isAddingQuestion = true"/>
                    </a-tooltip>
                  </div>
                <!-- </a-list-item> -->
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <div class="adding-heading-question" v-if="isAddingHeadingQuestion" style="margin-top: 20px;">
            <a-input v-model="newHeadingQuestion">
              <a-icon type="check" slot="addonAfter" @click="addHeadingQuestion()" />
            </a-input>
          </div>
          <div style="text-align: center; margin-top: 20px;">
            <a-tooltip>
              <template slot="title">
                Add Question Heading
              </template>
              <a-icon type="plus-circle" theme="twoTone" two-tone-color="#52c41a" :style="{fontSize: '30px'}" @click="isAddingHeadingQuestion = true"/>
            </a-tooltip>
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import dashHeader from '@src/views/dashboard/Header.vue';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';

import {
  mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';

export default {
  name: 'admin-assessment-framework',
  data() {
    return {
      selectedFrameworkId: this.$route.params.frameworkId,
      radioGroupKey: 0,
      currentStep: 0,
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Frameworks',
          route: '/dashboard/frameworks',
        },
        {
          name: 'Assessment Framework',
          route: '/dashboard/assessment-framework',
        },
      ],
      comfirmVisibility: false,
      expandIconPosition: 'left',
      editedSubTitle: '',
      editedQuestionHeading: '',
      editedQuestion: '',
      isAddingHeadingQuestion: false,
      isAddingQuestion: false,
      newHeadingQuestion: '',
      newQuestion: '',
      activeDomainChangeValue: '',
    };
  },
  components: {
    dashHeader,
    dashSidebar,
  },
  methods: {
          getDashboardTitle() {
    // This checks more thoroughly before trying to access `rendered`.
    if (this.frameworkDetails && this.frameworkDetails.title && typeof this.frameworkDetails.title.rendered === 'string') {
      return `${this.frameworkDetails.title.rendered} Framework`;
    }
    return 'Loading Framework...'; // A fallback or default title
  },
  async refetchData() {
    await this.fetchFrameworkQuestions(this.selectedFrameworkId);
    //await this.fetchFrameworkById(this.selectedFrameworkId);
    },
    async saveFrameworkUpdates() {
    const payload = {
      steps: this.steps, 
      userToken: this.userToken, 
      frameworkId: this.selectedFrameworkId
    };
    await this.updateFrameworkQuestionsAction(payload);
    this.refetchData(); // Refetch data after update
  },
    loadFrameworkQuestions(frameworkId) {
      this.$store.dispatch('frameworks/fetchFrameworkQuestions', frameworkId);
    },
    ...mapActions('frameworks', {
      fetchFrameworks: 'fetchFrameworks',
      fetchFrameworkById: 'fetchFrameworkById',
      fetchFrameworkQuestions: 'fetchFrameworkQuestions',
      updateFrameworkQuestionsAction: 'updateFrameworkQuestions',
    }),
    ...mapMutations('frameworks', {
      updateFrameworkQuestion: 'UPDATEFRAMEWORKQUESTIONS',
    }),
    handleStepClick(step) {
      this.currentStep = parseInt(step, 16);
    },
    handleEditSubTitle(event, currentStep) {
      event.stopPropagation();
      const actualData = {
        steps: this.steps,
        isEditing: true,
        updating: 'editSubtitleTrigger',
        currentStep,
      };
      this.updateFrameworkQuestion({ actualData });
    },
    udpateEditingSubTitle(event) {
      this.editedSubTitle = event.srcElement.value;
      event.stopPropagation();
    },
    updateSubTitle(event, tabIndex, oriSubTitle) {
      event.stopPropagation();
      if (this.editedSubTitle.length <= 0) {
        this.editedSubTitle = oriSubTitle;
      }
      const actualData = {
        steps: this.steps,
        isEditing: true,
        currentStep: this.currentStep,
        tabIndex,
        updating: 'editSubTitle',
        subTitleText: this.editedSubTitle,
      };
      this.updateFrameworkQuestion({ actualData });
      this.editedSubTitle = '';
    },
    handleEditHeading(event, tabIndex) {
      event.stopPropagation();
      const actualData = {
        steps: this.steps,
        isEditing: true,
        currentStep: this.currentStep,
        updating: 'editHeadingTrigger',
        tabIndex,
      };
      this.updateFrameworkQuestion({ actualData });
    },
    updateHeading(event, tabIndex, oriHeading) {
      event.stopPropagation();
      if (this.editedQuestionHeading.length <= 0) {
        this.editedQuestionHeading = oriHeading;
      }
      const actualData = {
        steps: this.steps,
        isEditing: true,
        currentStep: this.currentStep,
        tabIndex,
        updating: 'editHeading',
        headingText: this.editedQuestionHeading,
      };
      this.updateFrameworkQuestion({ actualData });
      this.editedQuestionHeading = '';
    },
    udpateEditingHeading(event) {
      this.editedQuestionHeading = event.srcElement.value;
      event.stopPropagation();
    },
    handleEditQuestion(event, tabIndex, questionIndex) {
      event.stopPropagation();
      const actualData = {
        steps: this.steps,
        isEditing: true,
        currentStep: this.currentStep,
        updating: 'editQuestionTrigger',
        tabIndex,
        questionIndex,
      };
      this.updateFrameworkQuestion({ actualData });
    },
    updateQuestion(event, tabIndex, questionIndex, oriQuestion) {
      event.stopPropagation();
      if (this.editedQuestion.length <= 0) {
        this.editedQuestion = oriQuestion;
      }
      const actualData = {
        steps: this.steps,
        isEditing: true,
        currentStep: this.currentStep,
        tabIndex,
        questionIndex,
        updating: 'editQuestion',
        questionText: this.editedQuestion,
      };
      this.updateFrameworkQuestion({ actualData });
      this.editedQuestion = '';
    },
    udpateEditingQuestion(event) {
      this.editedQuestion = event.srcElement.value;
    },
    checkAdminOnly(event, tabIndex, questionIndex) {
      const actualData = {
        steps: this.steps,
        isEditing: true,
        currentStep: this.currentStep,
        tabIndex,
        questionIndex,
        updating: 'editAdminOnly',
        questionText: this.editedQuestion,
        adminOnly: event.target.checked,
      };
      this.updateFrameworkQuestion({ actualData });
    },
    confirmDeleteHeading(tabIndex) {
      const actualData = {
        steps: this.steps,
        isEditing: false,
        currentStep: this.currentStep,
        tabIndex,
        updating: 'deleteHeading',
      };
      this.updateFrameworkQuestion({ actualData });
    },
    confirmDeleteQuestion(tabIndex, questionIndex) {
      const actualData = {
        steps: this.steps,
        isEditing: false,
        currentStep: this.currentStep,
        questionIndex,
        tabIndex,
        updating: 'deleteQuestion',
      };
      this.updateFrameworkQuestion({ actualData });
    },
    addHeadingQuestion() {
      const actualData = {
        steps: this.steps,
        isEditing: false,
        currentStep: this.currentStep,
        updating: 'addHeadingQuestion',
        newHeadingQuestion: this.newHeadingQuestion,
      };
      this.updateFrameworkQuestion({ actualData });
    },
    addQuestion(tabIndex) {
      const actualData = {
        steps: this.steps,
        isEditing: false,
        currentStep: this.currentStep,
        tabIndex,
        updating: 'addQuestion',
        newQuestion: this.newQuestion,
      };
      this.updateFrameworkQuestion({ actualData });
    },
    saveDomainScore(tabIndex, domainScoreKey, domainScoreValue) {
      const actualData = {
        steps: this.steps,
        isEditing: false,
        currentStep: this.currentStep,
        tabIndex,
        domainScoreKey,
        domainScoreValue,
        newDomainValue: this.activeDomainChangeValue,
        updating: 'updateDomain',
      };
      this.updateFrameworkQuestion({ actualData });
    },
    handleDomainChange(event) {
      this.activeDomainChangeValue = event.srcElement.value;
    },
    sortDomainScore(domainScoreValue) {
      const order = ['Yes', 'Yes But', 'No But', 'No'];
      const newOrder = [];
      Object.entries(domainScoreValue).map((a) => {
        newOrder.push({
          key: a[0],
          value: a[1],
        });
        return '';
      });
      newOrder.sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value));
      return newOrder;
    },
  },
  created() {
    this.refetchData();
    this.unsubscribe = this.$store.subscribe(async (mutation) => {
    if (mutation.type === 'frameworks/UPDATEFRAMEWORKQUESTIONS') {
      await this.saveFrameworkUpdates();
        this.newHeadingQuestion = '';
        this.isAddingHeadingQuestion = false;
        this.newQuestion = '';
        this.isAddingQuestion = false;
        this.activeDomainChangeValue = '';
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    this.fetchFrameworkQuestions(this.$route.params.frameworkId);
  },
  watch: {
      '$route.params.frameworkId': {
      immediate: true,
      handler(newVal) {
        this.fetchFrameworkById(newVal);
      }
    },
    },
  computed: {
      frameworkQuestions() {
    return this.$store.state.frameworks.frameworkQuestions;
  },
    ...mapState('frameworks', {
      // Directly use the state from the frameworks module
      frameworksList: state => state.frameworks,
      frameworkDetails: state => state.frameworkDetails,
      steps: state => state.frameworkQuestions,
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
  },
};
</script>
<style >
  span.edit-button:focus,
  span.edit-button i:focus{
    outline: none;
  }
  span.ant-input-group-addon:hover {
    background: #52c41a;
    color: #ffff;
  }
</style>
